import { axios } from '../axios';

const API_URL = `${process.env.VUE_APP_API_URL}/v1`;

const SettingsService = {
  getSettings: () => axios.get(`${API_URL}/setting/settings`),
  updateSettings: settings => axios.patch(`${API_URL}/setting/settings/default`, settings),
  getConfig: () => axios.get(`${API_URL}/setting/front-settings/default`),
};

export { SettingsService };
